import { createContext, useState, useContext, useEffect } from "react"
import Cookie from "js-cookie";
import axiosAWS from "../api/configAxios.js";

//para evitar errores creamos una variable global
var user = null;
//var user_autenticado = false;

export const AuthContext = createContext();

//esta es para poder exportar todo lo que indicamos en values
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within a AuthProvider");
    } else {
        return context;
    }
};



const delay = (time) => {
    return new Promise(resolve => setTimeout(resolve, time));
}

//la forma de poder pasar datos entre vistes es creando este context, dentro de este tabien se pueden definir funciones para agregar,editar y asi, para esta manera de una vez cachar dichos datos.
export const AuthProvider = ({ children }) => {

    //const [user, setUser] = useState(null);
    const [ip_public, setIp_public] = useState(null);
    const [style, setStyle] = useState(null);
    const [carga, setCarga] = useState(true);//false
    const [carga_validacion, setCarga_validacion] = useState(false);//false
    //esta hook lo usaremos para indicar que el usuario esta logeado
    //de igual manera lo indicamos en las values para poder usaralo o consultarlo en otros componentes
    const [user_autenticado, setUser_autenticado] = useState(false);
    const [id_lead, set_id_lead] = useState(null);
    const [utlexp, setultexp] = useState(null);
    const [favoritos, setFavoritos] = useState([]);
    const [Loadfavoritos, setLoadFavoritos] = useState(null);
    const [devToolsOpen, setDevToolsOpen] = useState(false);


    const setUser = (data) => {
        user = data;
    }

    const save_date_user = (user_values) => {
        if (user_values !== null) {
            //indicamos que el usuario en efecto esta logueado
            setUser_autenticado(true);
            setUser(user_values);
        }
    }

    const get_favoritos = async () => {
        const cookies = Cookie.get();
        var data_get = [];
        setLoadFavoritos(true);
        try {

            const result_data = await axiosAWS.post("catalogos", { "type": "Cat_favoritos_filt_user" }, { headers: { 'Authorization': `Bearer ${cookies.AutKeyPbi}` } }).catch(function (error) {
                if (error.response.status === 400) {
                    Cookie.remove("AutKeyPbi");
                    setUser(null);
                    setUser_autenticado(false);
                    return
                }

                if (error.response.status >= 500) {
                    //console.log("algo anda mal con la base de datos");
                    setUser(null);
                    setUser_autenticado(false);
                    return
                }
            });

            //console.log(result_data.data.result[0]);

            if (result_data.data.result[0].length !== 0) {
                setFavoritos(result_data.data.result[0])
                setLoadFavoritos(false);
                data_get = result_data.data.result[0];
            } else {
                setLoadFavoritos(false);
            }

        } catch (error) {
            setLoadFavoritos(false);
            setFavoritos(null)
        }
        return data_get;
    }

    const obtener_data = async () => {
        const cookies = Cookie.get();
        setCarga_validacion(true);
        try {

            const result_validate = await axiosAWS.post("login/validate_session", {}, { headers: { 'Authorization': `Bearer ${cookies.AutKeyPbi}` } }).catch(function (error) {
                if (error.response.status === 400) {
                    Cookie.remove("AutKeyPbi");
                    setUser(null);
                    setUser_autenticado(false);
                    return
                }

                if (error.response.status >= 500) {
                    //console.log("algo anda mal con la base de datos");
                    setUser(null);
                    setUser_autenticado(false);
                    return
                }
            });

            //console.log(result_validate.data.data);

            if (result_validate.data.data.user !== null) {

                if (result_validate.data.data.user === "error") {
                    setUser_autenticado(false);
                    setUser(null);
                    Cookie.remove("AutKeyPbi");

                    return
                }


                if (result_validate.status >= 200 || result_validate.status <= 299) {
                    setUser_autenticado(true);
                    var set_data_user = result_validate.data.data.user;
                    //console.log(result_validate.data...user)
                    setUser(
                        set_data_user
                    );
                    //get_favoritos();


                } else {
                    Cookie.remove("AutKeyPbi");

                    //window.location.href = window.location.href;
                }
            } else {
                Cookie.remove("AutKeyPbi");

                //window.location.href = window.location.href;
            }


        } catch (error) {

        }

        setCarga_validacion(false);
    }

    const validar_token_back = async () => {
        console.clear();
        setCarga(true);

        const cookies = Cookie.get();

        if (cookies.AutKeyPbi) {
            if (user === null && cookies.AutKeyPbi) {
                await obtener_data();
            } else {
                if (!user_autenticado) {
                    setUser_autenticado(true);
                }

            }

        } else {
            if (user_autenticado) {
                setUser_autenticado(false);
                setUser(null);
            }
        }
        //console.log("recarga");

        setCarga(false);


    }

    useEffect(() => {
        validar_token_back();
    }, [user_autenticado]);

    useEffect(() => {
        /*
        document.oncontextmenu = () => {
            return false;
        }

        document.addEventListener("keydown", (event) => {
            //console.log(event);
            if (event.ctrlKey && event.shiftKey && event.code === 'KeyI') {
               event.preventDefault();
                alert('¡Intento de abrir la consola detectado!');
            }

            if (event.metaKey && event.altKey && event.code === 'KeyI') {
                event.preventDefault();
                alert('¡Intento de abrir la consola detectado!');
            }
            if (event.metaKey && event.key === 's') {
                event.preventDefault();
                //alert('¡Intento descarga la pagina!');
            }
            if (event.ctrlKey && event.key === 's') {
                event.preventDefault();
                //alert('¡Intento descarga la pagina!');
            }
        });
        */

    }, [])


    useEffect(() => {
        const interval = setInterval(() => {
            const isOpen =
                window.outerWidth - window.innerWidth > 160 ||
                window.outerHeight - window.innerHeight > 160;

            if (isOpen !== devToolsOpen) {
                setDevToolsOpen(isOpen);

                if (isOpen) {
                    // Opcional: ocultar el contenido
                    // document.body.innerHTML = "";
                }
            }
        }, 500);

        return () => clearInterval(interval);
    }, [devToolsOpen]);

    //detectar juego de teclas para abrir el inspeccionar
    useEffect(() => {
        const bloquearTeclas = (e) => {
            if (
                e.key === "F12" ||
                (e.ctrlKey && e.shiftKey && e.key === "I") ||
                (e.ctrlKey && e.shiftKey && e.key === "J") ||
                (e.ctrlKey && e.key === "U")
            ) {
                e.preventDefault();
                e.stopPropagation();

                alert("Esta acción no está permitida.");
            }
        };

        const bloquearClickDerecho = (e) => {
            e.preventDefault();
        };

        document.addEventListener("keydown", bloquearTeclas);
        document.addEventListener("contextmenu", bloquearClickDerecho);

        return () => {
            document.removeEventListener("keydown", bloquearTeclas);
            document.removeEventListener("contextmenu", bloquearClickDerecho);
        };
    }, []);

    if (!devToolsOpen) {
        //aqui indicamos los valores que deseamos exportar
        return (
            <AuthContext.Provider value={
                {
                    user,
                    carga_validacion,
                    obtener_data,
                    user_autenticado,
                    ip_public,
                    setUser,
                    setIp_public,
                    save_date_user,
                    setUser_autenticado,
                    utlexp,
                    setultexp,
                    get_favoritos,
                    favoritos,
                    Loadfavoritos
                }
            }>
                {
                    carga ?
                        <div className="col-12 d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                            cargando..
                        </div>
                        :
                        children
                }
            </AuthContext.Provider>
        )
    } else {
        <div className="col-12 d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
            Sin elementos que monstrar
        </div>
    }



}

